import type {
  AbilityFeature,
  DesignerAbilityConfigSource,
  RequiredStores,
} from './types';

export function abilityFeature<
  Key extends keyof DesignerAbilityConfigSource,
  Stores extends keyof RequiredStores =
    DesignerAbilityConfigSource[Key]['stores'],
>(config: AbilityFeature<Key, Stores>): AbilityFeature<Key, Stores> {
  return config;
}
